/**
 * MUI theme factory for DataTable.
 * Pass the current `dark` boolean to get a fully configured MUI theme object
 * suitable for use with `createTheme()`.
 *
 * Usage:
 *   import { tableTheme } from '../../ui/table-v3/theme';
 *   const memoTheme = useMemo(() => createTheme(tableTheme(dark)), [dark]);
 */
export const tableTheme = (dark) => ({
  palette: {
    mode: dark ? "dark" : "light",
  },
  typography: {
    fontFamily: ["Inter"],
    button: {
      textTransform: "none",
      fontSize: "12px",
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          "& .MuiBox-root:has(.MuiTablePagination-root) .MuiTablePagination-root": {
            padding: "0px !important",
          },
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundColor: `${dark ? "rgba(30,30,30,1)" : "#ffffff"} !important`,
          color: `${dark ? "rgba(255,255,255,0.9)" : "rgba(0,0,0,0.87)"} !important`,
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: `${dark ? "rgba(30,30,30,1)" : "#ffffff"} !important`,
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          color: `${dark ? "rgba(255,255,255,0.9)" : "rgba(0,0,0,0.87)"}`,
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          padding: "0px !important",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        head: {
          boxShadow: "unset !important",
        },
        root: {
          boxShadow: "unset !important",
          "&:hover td:not(.Mui-TableBodyCell-DetailPanel)": {
            transition: "all none !important",
            backgroundColor: `${dark ? "rgba(43,43,43,1)" : "rgba(220,220,230,1)"} !important`,
          },
          "& td:not(.Mui-TableBodyCell-DetailPanel)": {
            transition: "all none !important",
            backgroundColor: `${dark ? "rgba(32,32,32,1)" : "var(--table-row-bg-color)"} !important`,
          },
          "& td:after": {
            backgroundColor: "rgba(255,0,0,0) !important",
          },
          "&:first-of-type": {
            borderRadius: "8px 0 0 0 !important",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          borderBottom: `0px solid ${dark ? "rgba(22,22,22,1)" : "rgba(180,180,195,1)"}`,
          backgroundColor: `${dark ? "rgba(0,0,0,1)" : "var(--table-header-bg-color)"} !important`,
        },
        root: {
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          paddingLeft: "10px !important",
          paddingRight: "10px !important",
          font: "12px Inter",
          backgroundColor: `${dark ? "rgba(36,36,36,1)" : "var(--table-row-bg-color)"} !important`,
          borderBottom: `1px solid ${dark ? "rgba(22,22,22,1)" : "rgba(243,243,243,1)"}`,
          color: `${dark ? "rgba(255,255,255,1) !important" : "rgba(0,0,0,1) !important"}`,
          "& div:first-of-type": {},
          "&.Mui-TableBodyCell-DetailPanel": {
            paddingLeft: "0px !important",
            paddingRight: "0px !important",
            border: "0px solid red !important",
          },
        },
      },
    },
  },
});
